import { ConfigProvider as AntdProvider } from "antd";
import dayjs from "dayjs";
import indonesia from "locales/id-ID";
import english from "locales/en-US";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { localeSelector } from "appredux/selectors";
import "locales";

const locales = {
  "en-US": english,
  "id-ID": indonesia,
};

const ConfigProvider = ({ children }) => {
  const locale = useSelector(localeSelector);
  const { i18n } = useTranslation();

  const setLocale = useCallback(() => {
    if (locale === "id-ID") {
      dayjs.locale("id");
      i18n.changeLanguage(locale);
    } else {
      dayjs.locale("en");
      i18n.changeLanguage(locale);
    }
  }, [i18n, locale]);

  useEffect(() => {
    if (locale) {
      setLocale();
    }
  }, [locale, setLocale]);

  // useEffect(() => {
  //   message.config({
  //     maxCount: 1,
  //   });
  // }, []);

  const currentLocale = locales[locale];

  return (
    <AntdProvider
      theme={{
        token: {
          colorPrimary: "#4777F3",
        },
      }}
      locale={currentLocale.antdData}
    >
      {children}
    </AntdProvider>
  );
};

export default ConfigProvider;
